import Tabs from './TabsContainer';

export default Tabs;
